import { useQuery } from '@tanstack/react-query';

import { gatewayApiAgent } from 'common/api/apiAgents';
import { Warehouse } from 'common/api-types/director';

/** Matches `useWarehouseQuery` — invalidate with `[WAREHOUSES_QUERY_KEY_ROOT, warehouseId]`. */
export const WAREHOUSES_QUERY_KEY_ROOT = 'warehouses';

const fetchWarehouse = async (warehouseId: string) => {
  const response = await gatewayApiAgent.get<Warehouse>(
    `/director/public/v1/warehouses/${warehouseId}`,
  );

  return response.data;
};

export const useWarehouseQuery = (warehouseId: string) =>
  useQuery({
    queryKey: [WAREHOUSES_QUERY_KEY_ROOT, warehouseId],
    queryFn: () => fetchWarehouse(warehouseId),
    enabled: !!warehouseId,
  });
